import { KeyboardEvent } from 'react';

/** Input types that act as buttons, where Enter is meant to press them. */
const BUTTON_INPUT_TYPES = new Set(['submit', 'button', 'reset', 'image']);

/**
 * Stops Enter in a text-like input from submitting the surrounding form.
 *
 * Browsers treat Enter in an `<input>` as a click on the form's default submit button
 * (implicit submission). Attach this as the form's `onKeyDown` when the form should only
 * be submitted by its button. Textareas, rich-text editors and buttons keep their
 * usual Enter behavior, and so does Enter that commits an IME composition.
 * React portals bubble keydown through the React tree, so Enter in an input of a portal
 * rendered inside the form (e.g. a modal with its own form) is prevented too.
 * @param e - Keydown event bubbled up to the form.
 */
export const preventImplicitSubmit = (e: KeyboardEvent<HTMLFormElement>) => {
  if (e.key !== 'Enter' || e.nativeEvent.isComposing) return;

  const { target } = e;
  if (
    target instanceof HTMLInputElement &&
    !BUTTON_INPUT_TYPES.has(target.type)
  ) {
    e.preventDefault();
  }
};
